import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";
import Perfil from "../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../redux/auth/actions";
import { withRouter } from "react-router";
import toastr from "toastr";
import { getNotificationPath } from "../pages/Modulo_Notificaciones/utils";

//agregado
// import { getAuth } from '../redux/auth/actions';

const SidebarDashboard = (props) => {
  const dispatch = useDispatch();
  const userId = useSelector((store) => store.auth.id);
  //const username = useSelector(store => store.auth.username);
  const userPic = useSelector((store) => store.auth.pic);
  const userRoles = useSelector((store) => store.auth.userRoles);
  const unidOrg = useSelector((store) => store.auth.unidOrg);
  const unidName = useSelector((store) => store.auth.unidName);
  const userOrg = useSelector((store) => store.auth.userOrg);
  const userType = useSelector((store) => store.auth.userType);
  const userN = useSelector((store) => store.auth.name);
  const employee = useSelector((store) => store.employees.employee);

  let id_descriptor;
  let name_descriptor;
  let id_func;
  let nombre_func;
  if (employee && employee.descriptor_List && employee.Funciones_List) {
    id_descriptor = employee.descriptor_List.id;
    name_descriptor = employee.descriptor_List.nombre_posicion;
    id_func = employee.Funciones_List[0].id;
    nombre_func = employee.Funciones_List[0].descripcion;
  }
  //console.log("Roles - ", userRoles);

  //const userPic = useSelector(store => store.auth.pic);
  //agregado
  // useEffect(() => {
  //   dispatch(getAuth());
  // }, [dispatch])

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };

  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <div className="d-block d-sm-block d-md-none">
              <SubMenu
                title={userN}
                icon={
                  <img
                    src={!!userPic ? userPic : Perfil}
                    className="user-pic"
                    alt=""
                  />
                }
              >
                <MenuItem style={{ borderBottom: "2px solid white" }}>
                  <Link to={`/perfil-usuario/${userId}/${userType}`}>
                    Mi perfil
                  </Link>
                </MenuItem>
                <MenuItem onClick={onSignOut}>Cerrar sesión</MenuItem>
              </SubMenu>
              <MenuItem icon={<i className="material-icons">notifications</i>}>
                <Link to="/#!">Notificaciones</Link>
              </MenuItem>
              <div className="row no-gutters"></div>
            </div>
            <SubMenu
              title="Headcount"
              icon={<i className="material-icons">groups</i>}
            >
              {userRoles.length > 0 &&
              (userRoles.includes("jefe") ||
                userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Headcount")) ? (
                <MenuItem icon={<i className="material-icons">group</i>}>
                  {/* <Link to="/dashboard-plazas-y-contrataciones-jefes"> */}
                  <Link to="/indicador-headcount">
                    {/* Indicadores plazas y cont. */}
                    Indicador Headcount
                  </Link>
                </MenuItem>
              ) : null}
              {
                //*userRoles[0].toString().toLowerCase() === 'administrador'
                userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("Responsable_Headcount")) ? (
                  <MenuItem icon={<i className="material-icons">group</i>}>
                    {/* <Link to="/dashboard-plazas-cont-admin"> */}
                    <Link to="/tablero-headCount">
                      {/* Indicadores. plazas y cont. */}
                      Tablero HeadCount
                    </Link>
                  </MenuItem>
                ) : null
              }
              {userRoles.length > 0 &&
              (userRoles.includes("jefe") ||
                userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Headcount")) ? (
                <MenuItem icon={<i className="material-icons">group</i>}>
                  <Link to="/reloj-marcador">Reloj Marcador</Link>
                </MenuItem>
              ) : null}
              <MenuItem icon={<i className="material-icons">group</i>}>
                <Link to={`/detalle-empleado/${userId}/${userType}`}>
                  Ficha de empleado
                </Link>
              </MenuItem>
              {userRoles.length > 0 &&
              (userRoles.includes("jefe") ||
                userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Headcount")) ? (
                <MenuItem icon={<i className="material-icons">group</i>}>
                  <Link to={`/wfh-teletrabajo`}>WFH Teletrabajo</Link>
                </MenuItem>
              ) : null}

              {userRoles.length > 0 &&
              (userRoles.includes("jefe") ||
                userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Headcount")) ? (
                <MenuItem icon={<i className="material-icons">group</i>}>
                  <Link to={`/marcaje-ctm`}>Marcaje CTM</Link>
                </MenuItem>
              ) : null}

              {userRoles.length > 0 &&
              (userRoles.includes("alta_direccion") ||
                userRoles.includes("administrador") ||
                userRoles.includes("alta_direccion") ||
                userRoles.includes("Responsable_Headcount")) ? (
                <MenuItem icon={<i className="material-icons">group</i>}>
                  <Link to={`/desarrollo-personal`}>Desarrollo Personal</Link>
                </MenuItem>
              ) : null}
            </SubMenu>
            {userRoles.length > 0 && userRoles.includes("jefe") ? (
              <>
                <MenuItem
                  icon={<i className="material-icons">folder_shared</i>}
                >
                  <Link
                    to={`/inventario-de-personal/${userOrg}/${unidName.replaceAll(
                      "/",
                      "-"
                    )}/1/00/${userType}/00`}
                  >
                    Inv. Personal
                  </Link>
                </MenuItem>
                <MenuItem
                  title="Estruc. área"
                  icon={<i className="material-icons">account_tree</i>}
                >
                  <Link
                    to={`/estructura-unidad/${unidOrg}/${unidName.replace(
                      "/",
                      "-"
                    )}/${userType}`}
                  >
                    Estructura Org.
                  </Link>
                </MenuItem>
              </>
            ) : null}
            {userRoles.length > 0 && userRoles.includes("alta_direccion") ? (
              <>
                <MenuItem
                  icon={<i className="material-icons">folder_shared</i>}
                >
                  <Link to={`/filtrar-empresas/2`}>Inv. Personal</Link>
                </MenuItem>
                <MenuItem
                  title="Estruc. área"
                  icon={<i className="material-icons">account_tree</i>}
                >
                  <Link to={`/empresas/2`}>Estructura Org.</Link>
                </MenuItem>
              </>
            ) : null}
            {
              //*userRoles[0].toString().toLowerCase() === 'empleado'
              userRoles.length > 0 && userRoles.includes("empleado") ? (
                <>
                  <MenuItem
                    title="Estruc. área"
                    icon={<i className="material-icons">account_tree</i>}
                  >
                    <Link
                      to={`/estructura-unidad/${unidOrg}/${unidName.replace(
                        "/",
                        "-"
                      )}/${userType}`}
                    >
                      Estructura Org.
                    </Link>
                  </MenuItem>
                </>
              ) : null
            }
            {
              //*userRoles[0].toString().toLowerCase() === 'administrador'
              userRoles.length > 0 && userRoles.includes("administrador") ? (
                <>
                  <SubMenu
                    title="Inv. personal"
                    icon={<i className="material-icons">folder_shared</i>}
                  >
                    <MenuItem>
                      <Link to="/filtrar-empresas/1">Formal</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/filtrar-empresas/2">Funcional</Link>
                    </MenuItem>
                  </SubMenu>
                  <SubMenu
                    title="Estruc. área"
                    icon={<i className="material-icons">account_tree</i>}
                  >
                    <MenuItem>
                      <Link to="/empresas/1">Formal</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link to="/empresas/2">Funcional</Link>
                    </MenuItem>
                  </SubMenu>
                </>
              ) : null
            }
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("Responsable_OnBoarding") ||
              userRoles.includes("alta_direccion") ||
              userRoles.includes("empleado") ||
              userRoles.includes("jefe")) ? (
              <>
                <SubMenu
                  title="OnBoarding"
                  icon={<i className="material-icons">group_work</i>}
                >
                  {userRoles.length > 0 &&
                  (userRoles.includes("Responsable_OnBoarding") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("empleado") ||
                    userRoles.includes("jefe")) ? (
                    <MenuItem>
                      {userRoles &&
                      (userRoles.includes("jefe") ||
                        userRoles.includes("Responsable_OnBoarding") ||
                        userRoles.includes("Responsable_OffBoarding") ||
                        userRoles.includes("administrador")) ? (
                        <Link to="/Monitor/OnBoarding/1">Monitor</Link>
                      ) : (
                        <Link to="/monitorBording/taksListBording/1">
                          Actividades
                        </Link>
                      )}
                    </MenuItem>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Responsable_OnBoarding") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <MenuItem>
                      {/* <Link to="/Dashboard/OnBoarding"> */}
                      <Link to="/Indicador/OnBoarding">
                        {/* Dashboard OnBoarding */}
                        Indicador OnBoarding
                      </Link>
                    </MenuItem>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("administrador") ||
                    userRoles.includes("alta_direccion") ||
                    // userRoles.includes("jefe") ||
                    userRoles.includes("Responsable_OnBoarding")) ? (
                    <MenuItem>
                      {/* <Link to="/Dashboard-Onboarding-PowerBI"> */}
                      <Link to="/Tablero-Onboarding-PowerBI">
                        {/* Dashboard PowerBI */}
                        Tablero OnBoarding
                      </Link>
                    </MenuItem>
                  ) : null}
                </SubMenu>
              </>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("Responsable_OffBoarding") ||
              userRoles.includes("jefe") ||
              userRoles.includes("empleado") ||
              userRoles.includes("alta_direccion") ||
              userRoles.includes("Responsable_Headcount") ||
              userRoles.includes("Responsable_Sanciones") ||
              userRoles.includes("Encargado_Sanciones")) ? (
              <>
                <SubMenu
                  title="OffBoarding"
                  icon={<i className="material-icons">person_remove_alt_1</i>}
                >
                  {userRoles.length > 0 &&
                  (userRoles.includes("Responsable_OffBoarding") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("empleado") ||
                    userRoles.includes("jefe") ||
                    userRoles.includes("Responsable_Headcount")) ? (
                    <MenuItem>
                      {userRoles &&
                      (userRoles.includes("jefe") ||
                        userRoles.includes("Responsable_OnBoarding") ||
                        userRoles.includes("Responsable_OffBoarding") ||
                        userRoles.includes("administrador") ||
                        userRoles.includes("Responsable_Headcount")) ? (
                        <Link to="/Monitor/OffBoarding/2">Monitor</Link>
                      ) : (
                        <Link to="/monitorBording/taksListBording/2">
                          Actividades
                        </Link>
                      )}
                    </MenuItem>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("Responsable_Headcount")) ? (
                    // ||
                    //   userRoles.includes("jefe")
                    <MenuItem>
                      <Link to="/monitor-bajas">Monitor de bajas</Link>
                    </MenuItem>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Responsable_OffBoarding") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <MenuItem>
                      {/* <Link to="/Dashboard/OffBoarding"> */}
                      <Link to="/Indicador/OffBoarding">
                        {/* Indicador OffBoarding */}
                        Indicador OffBoarding
                      </Link>
                    </MenuItem>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("administrador") ||
                    userRoles.includes("alta_direccion") ||
                    // userRoles.includes("jefe") ||
                    userRoles.includes("Responsable_OffBoarding") ||
                    userRoles.includes("Responsable_Headcount") ||
                    userRoles.includes("Responsable_Sanciones") ||
                    userRoles.includes("Encargado_Sanciones")) ? (
                    <>
                      {userRoles.includes("administrador") ||
                      userRoles.includes("alta_direccion") ||
                      // userRoles.includes("jefe") ||
                      userRoles.includes("Responsable_OffBoarding") ? (
                        <MenuItem>
                          {/* <Link to="/Dashboard-Encuestas-de-Salida"> */}
                          <Link to="/Tablero-Encuestas-de-Salida">
                            {/* Dashboard Encuestas de Salida */}
                            Tablero Encuestas de Salida
                          </Link>
                        </MenuItem>
                      ) : null}
                      {/* {userRoles.includes("Responsable_Headcount") && ( */}
                      <MenuItem>
                        {/* <Link to="/Dashboard-Offboarding-PowerBI"> */}
                        <Link to="/Tablero-Offboarding-PowerBI">
                          {/* Dashboard PowerBI */}
                          Tablero Offboarding
                        </Link>
                      </MenuItem>
                      {/* )} */}
                    </>
                  ) : null}
                </SubMenu>
              </>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("Responsable_Sanciones") ||
              userRoles.includes("administrador") ||
              userRoles.includes("jefe")) ? (
              <>
                <SubMenu
                  title="Módulo Disciplinario"
                  icon={<i className="material-icons">gavel</i>}
                >
                  {(userRoles.includes("Responsable_Sanciones") ||
                    userRoles.includes("administrador")) && (
                    <>
                      <MenuItem>
                        <Link to={`/categorias-desvinculación`}>
                          Categoría de Desvinculación
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link to={`/motivo-acciones-disciplinarias`}>
                          Motivo Disciplinario
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link to={`/tipos-acciones-disciplinarias`}>
                          Tipos de acciones
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link to={`/medidas-disciplinarias`}>
                          Medidas Disciplinarias
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        <Link to={`/tipo-falta`}>Tipo Falta</Link>
                      </MenuItem>
                      <MenuItem>
                        <Link to={`/sansiones-estatus`}>Estatus</Link>
                      </MenuItem>
                      <MenuItem>
                        <Link to={`/Holidays`}>Días Festivos</Link>
                      </MenuItem>
                    </>
                  )}
                  <MenuItem>
                    <Link to={`/sansiones-formatos`}>Formatos</Link>
                  </MenuItem>
                </SubMenu>
              </>
            ) : null}
            {userRoles.length > 0 &&
              (userRoles.includes("Responsable_Sanciones") ||
                userRoles.includes("Encargado_Sanciones") ||
                userRoles.includes("administrador") ||
                userRoles.includes("alta_direccion") ||
                userRoles.includes("jefe")) && (
                <SubMenu
                  title="Medidas Disciplinarias"
                  icon={<i className="material-icons">pan_tool</i>}
                >
                  {userRoles.length > 0 &&
                    (userRoles.includes("Responsable_Sanciones") ||
                      userRoles.includes("Encargado_Sanciones") ||
                      userRoles.includes("alta_direccion") ||
                      userRoles.includes("administrador") ||
                      userRoles.includes("jefe")) && (
                      <MenuItem>
                        <Link to={`/casos-disciplinarios`}>
                          Casos Disciplinarios
                        </Link>
                      </MenuItem>
                    )}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("alta_direccion") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <>
                      <MenuItem>
                        <Link to={`/acciones-disciplinarias`}>
                          Acciones Disciplinarias
                        </Link>
                      </MenuItem>
                    </>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("alta_direccion") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <>
                      <MenuItem>
                        <Link to={`/reincidencias`}>Reincidencias</Link>
                      </MenuItem>
                    </>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("alta_direccion") ||
                    userRoles.includes("administrador") ||
                    userRoles.includes("jefe")) ? (
                    <>
                      <MenuItem>
                        <Link to={`/programacion-audiencias`}>
                          Programar Audiencias
                        </Link>
                      </MenuItem>
                    </>
                  ) : null}
                  {userRoles.length > 0 &&
                  (userRoles.includes("administrador") ||
                    userRoles.includes("alta_direccion") ||
                    userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("Responsable_Sanciones")) ? (
                    <>
                      <MenuItem>
                        {/* <Link to={`/Dashboard-Sanciones-PowerBI`}> */}
                        <Link to={`/Tablero-Sanciones`}>
                          {/* Dashboard PowerBI */}
                          Tablero Disciplinario
                        </Link>
                      </MenuItem>
                    </>
                  ) : null}
                </SubMenu>
              )}
            {/* {userRoles.length > 0 &&
            userRoles.includes("administrador") &&
            !userRoles.includes("responsable") ? (
              <>
                <SubMenu
                  title="Clima Laboral"
                  icon={<i className="material-icons">cloud</i>}
                >
                  <MenuItem>
                    <Link to="/Reporte-Clima-Laboral">
                      Reporte Clima Laboral{" "}
                    </Link>
                  </MenuItem>
                </SubMenu>
              </>
            ) : null} */}
            {(userRoles.length > 0 && userRoles.includes("responsable")) ||
            userRoles.includes("administrador") ? (
              <>
                <SubMenu
                  title="Clima Laboral"
                  icon={<i className="material-icons">cloud</i>}
                >
                  <MenuItem>
                    <Link to="/Indicador-Clima-Laboral">
                      Indicador Clima Laboral
                    </Link>
                  </MenuItem>
                  <MenuItem>
                    {/* <Link to="/Reporte-Clima-Laboral"> */}
                    <Link to="/Tablero-Clima-Laboral">
                      {/* Reporte Clima Laboral{" "} */}
                      Tablero Clima Laboral
                    </Link>
                  </MenuItem>
                </SubMenu>
              </>
            ) : null}
            {
              //*userRoles[0].toString().toLowerCase() === 'administrador'
              userRoles.length > 0 && userRoles.includes("administrador") ? (
                <MenuItem icon={<i className="material-icons">settings</i>}>
                  <Link to="/configuracion">Configuración</Link>
                </MenuItem>
              ) : null
            }
            {(userRoles.length > 0 && userRoles.includes("responsable")) ||
            (userRoles.length > 0 && userRoles.includes("administrador")) ? (
              <MenuItem icon={<i className="material-icons">cloud_queue</i>}>
                <Link to="/configuración-clima">
                  Configuración clima laboral
                </Link>
              </MenuItem>
            ) : null}
            {/* {
              userRoles.length > 0 &&
              userRoles.includes("responsable") &&
              !userRoles.includes("administrador") ? (
                <MenuItem icon={<i className="material-icons">cloud_queue</i>}>
                  <Link to="/configuración-clima">
                    Configuración clima laboral
                  </Link>
                </MenuItem>
              ) : null
            } */}
            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <MenuItem
                icon={<i className="material-icons">connect_without_contact</i>}
              >
                <Link to="/Administración-On-Off-Boarding">
                  Configuración Boarding
                </Link>
              </MenuItem>
            ) : null}
            {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion") ||
                userRoles.includes("Responsable_Carrera") ||
                userRoles.includes("Responsable_Carrera_Sucesion") ||
                userRoles.includes("Responsable_Descriptores_Perfiles") ||
                userRoles.includes("responsable_desempeno_laboral") ||
                userRoles.includes("Responsable_Evaluacion") ||
                userRoles.includes("Responsable_Headcount") ||
                userRoles.includes("Responsable_OffBoarding") ||
                userRoles.includes("Responsable_OnBoarding") ||
                userRoles.includes("Responsable_Sanciones") ||
                userRoles.includes("Responsable_Seleccion_Contratacion") ||
                userRoles.includes("Encargado_Sanciones")
              ) ? (
              <SubMenu
                title="Módulo Notificaciones"
                icon={<i className="material-icons">notifications_active</i>}
              >
                {getNotificationPath(userRoles) && ( <MenuItem>
                  <Link to={getNotificationPath(userRoles)}>
                    Monitor Notificaciones
                  </Link>
                </MenuItem>)}
                {userRoles.length > 0 && userRoles.includes("administrador") && (
                  <MenuItem>
                    <Link to="/conf-notificaciones/admin">
                      Administración
                    </Link>
                  </MenuItem>
                )}
              </SubMenu>

            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("jefe") ||
              userRoles.includes("alta_direccion") ||
              userRoles.includes("Responsable_Descriptores_Perfiles") ||
              userRoles.includes("empleado")) ? (
              <SubMenu
                title="Descriptores y perfiles"
                icon={<i className="material-icons">manage_accounts</i>}
              >
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("jefe") ||
                  userRoles.includes("empleado")) ? (
                  !!id_descriptor &&
                  !!name_descriptor &&
                  !!id_func &&
                  !!nombre_func ? (
                    <MenuItem>
                      <Link
                        to={`/descriptor-perfil/mi-descriptor/${id_descriptor}/${name_descriptor}/${id_func}/${nombre_func}`}
                      />
                      Mi descriptor
                    </MenuItem>
                  ) : (
                    <MenuItem
                      onClick={() =>
                        toastr.info("El usuario no tiene Descriptor")
                      }
                    >
                      Mi descriptor
                    </MenuItem>
                  )
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("jefe") ||
                  userRoles.includes("Responsable_Descriptores_Perfiles")) ? (
                  <MenuItem>
                    <Link to="/descriptores-perfiles/manuales-competencias">
                      Manual de competencias
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Descriptores_Perfiles") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("jefe")) ? (
                  <MenuItem>
                    <Link to="/descriptores-perfiles/menu-usuario">
                      Manual de puesto y funciones
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  // userRoles.includes("alta_direccion") ||
                  userRoles.includes("Responsable_Descriptores_Perfiles")) ? (
                  <MenuItem>
                    {/* <Link to="/descriptores-perfiles/dashboard-descriptor-puesto"> */}
                    <Link to="/descriptores-perfiles/tablero-descriptores-de-puesto">
                      {/* Dashboard descriptores de puesto */}
                      Tablero Descriptores de Puesto
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Descriptores_Perfiles")) ? (
                  <MenuItem>
                    <Link to="/descriptores-perfiles/mantenimientos">
                      Administración
                    </Link>
                  </MenuItem>
                ) : null}
              </SubMenu>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("jefe") ||
              userRoles.includes("alta_direccion") ||
              userRoles.includes("Responsable_Seleccion_Contratacion")) ? (
              <SubMenu
                title="Selección y contratación"
                icon={<i className="material-icons">markunread_mailbox</i>}
              >
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("Responsable_Seleccion_Contratacion") ||
                  userRoles.includes("jefe")) ? (
                  <MenuItem>
                    <Link to="/seleccion-contratacion/plazas-vacantes">
                      Plazas vacantes
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("Responsable_Seleccion_Contratacion") ||
                  userRoles.includes("jefe")) ? (
                  <MenuItem>
                    <Link to="/seleccion-contratacion/plazas-no-vacantes">
                      Plazas no vacantes
                    </Link>
                  </MenuItem>
                ) : null}
                {(userRoles.length > 0 &&
                  userRoles.includes("administrador")) ||
                userRoles.includes("Responsable_Seleccion_Contratacion") ? (
                  <MenuItem>
                    <Link to="/seleccion-contratacion/mantenimientos/admin">
                      Administración
                    </Link>
                  </MenuItem>
                ) : null}
                <MenuItem icon={<i className="material-icons">emoji_events</i>}>
                  {/* <Link to="/seleccion-contratacion/dashboardSeleccionContratacion"> */}
                  <Link to="/seleccion-contratacion/indicadores/indicador-selección-y-contratacion">
                    {/* Dashboard */}
                    Indicador Selección y Contratación
                  </Link>
                </MenuItem>
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("Responsable_Seleccion_Contratacion")) ? (
                  <>
                    <MenuItem>
                      {/* <Link to={`/Dashboard-Seleccion-Contratacion-PowerBI`}> */}
                      <Link to={`/tablero-selección-y-contratación`}>
                        {/* Dashboard PowerBI */}
                        Tablero Selección y Contratación
                      </Link>
                    </MenuItem>
                  </>
                ) : null}
              </SubMenu>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("jefe") ||
              userRoles.includes("alta_direccion") ||
              userRoles.includes("Responsable_Evaluacion")) ? (
              <SubMenu
                title="Evaluación del desempeño"
                icon={<i className="material-icons">trending_up</i>}
              >
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("alta_direccion") ||
                  userRoles.includes("Responsable_Evaluacion") ||
                  userRoles.includes("jefe")) ? (
                  <MenuItem>
                    <Link to="/evaluacion-desempenio/monitor-de-colaboradores">
                      Colaboradores
                    </Link>
                  </MenuItem>
                ) : null}
                {(userRoles.length > 0 && userRoles.includes("jefe")) ||
                userRoles.includes("alta_direccion") ||
                userRoles.includes("administrador") ? (
                  <MenuItem>
                    {/* <Link to="/evaluacion-desempenio/dashboard-jefe"> */}
                    <Link to="/evaluacion-desempenio/indicador-evaluaciones-de-desempeño">
                      {/* Dashboard Jefes */}
                      Indicador Evaluaciones de Desempeño
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Evaluacion") ||
                  userRoles.includes("alta_direccion")) ? (
                  <MenuItem>
                    {/* <Link to="/evaluacion-desempenio/dashboard-responsable"> */}
                    <Link to="/evaluacion-desempenio/tablero-evaluaciones-de-desempeño">
                      {/* Dashboard responsable */}
                      Tablero Evaluaciones de Desempeño
                    </Link>
                  </MenuItem>
                ) : null}
                {(userRoles.length > 0 &&
                  userRoles.includes("administrador")) ||
                userRoles.includes("Responsable_Evaluacion") ? (
                  <MenuItem>
                    <Link to="/evaluacion-desempenio/admin">
                      Administración
                    </Link>
                  </MenuItem>
                ) : null}
              </SubMenu>
            ) : null}

            {(userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("jefe") ||
                userRoles.includes("empleado"))) ||
            userRoles.includes("Responsable_Capacitacion") ||
            userRoles.includes("alta_direccion") ? (
              <SubMenu
                title="Capacitación y desarrollo"
                icon={<i className="material-icons">model_training</i>}
              >
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion")) ? (
                  <MenuItem>
                    {/* <Link to="/capacitacion-desarrollo/indicadores-capacitacion"> */}
                    <Link to="/capacitacion-desarrollo/tablero-capacitaciones">
                      {/* Indicadores capacitaciòn */}
                      Tablero Capacitaciones
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion")) ? (
                  <MenuItem>
                    <Link to="/capacitacion-desarrollo/control-presupuesto">
                      Control de Presupuesto
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion") ||
                  userRoles.includes("jefe")) && (
                  <MenuItem>
                    <Link to="/capacitacion-desarrollo/gestion-necesidades">
                      Gestión de Necesidades
                    </Link>
                  </MenuItem>
                )}
                <MenuItem>
                  <Link to="/capacitacion-desarrollo/monitor-colaboradores">
                    Monitor de Colaboradores
                  </Link>
                </MenuItem>
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion")) ? (
                  <MenuItem>
                    <Link to="/capacitacion-desarrollo/monitor-colaboradores-evaluables">
                    Monitor Evaluables
                    </Link>
                  </MenuItem>
                ) : null}

                {userRoles.length > 0 &&
                (userRoles.includes("empleado") ||
                  userRoles.includes("jefe")) ? (
                  <MenuItem>
                    <Link to="/capacitacion-desarrollo/registro-cursos">
                    Acceso Cursos
                    </Link>
                  </MenuItem>
                ) : null}
                
                {userRoles.length > 0 &&
                (userRoles.includes("empleado")) ? (
                  <MenuItem>
                    <Link to="/capacitacion-desarrollo/calendario-capacitaciones">
                    Calendario Capacitaciones
                    </Link>
                  </MenuItem>
                ) : null}

                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion")||
                  userRoles.includes("jefe")) ? (
                  <MenuItem>
                    <Link to={`/capacitacion-desarrollo/rutas-capacitacion`}>
                      Ruta de capacitación
                    </Link>
                  </MenuItem>
                ) : null}
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion")) ? (
                  <MenuItem>
                    <Link to="/capacitacion-desarrollo/admin">
                      Administración
                    </Link>
                  </MenuItem>
                ) : null}
              </SubMenu>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("Responsable_Carrera")) ? (
              <SubMenu
                title="Plan de Carrera"
                icon={<i className="material-icons">assignment_ind</i>}
              >
                <MenuItem>
                  <Link to="/plan-carrera/planes">Planes</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/plan-carrera/admin">Administración</Link>
                </MenuItem>
              </SubMenu>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("Responsable_Carrera_Sucesion")) ? (
              <SubMenu
                title="Plan de Sucesión"
                icon={<i className="material-icons">next_week</i>}
              >
                <MenuItem>
                  <Link to="/sucesion/matriz-de-evaluación-de-puesto">
                    Matriz de evaluación de puesto
                  </Link>
                </MenuItem>

                <MenuItem>
                  <Link to={`/sucesion/matriz-sucecion`}>
                    Matriz de Sucesión
                  </Link>
                </MenuItem>
                <MenuItem>Tablero carrera y sucesión</MenuItem>
                <MenuItem>
                  <Link to="/sucesion/admin">Administración</Link>
                </MenuItem>
              </SubMenu>
            ) : null}
            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("jefe")) ? (
              <SubMenu
                title="Gestión de tiempos"
                icon={<i className="material-icons">event</i>}
              >
                {userRoles.length > 0 &&
                (userRoles.includes("jefe") ||
                  userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Headcount")) ? (
                  <MenuItem icon={<i className="material-icons">group</i>}>
                    <Link to="/gestión-de-tiempos">Gestión de tiempos</Link>
                  </MenuItem>
                ) : null}
                <MenuItem>
                  <Link to="/saldo-vacaciones">Saldo de vacaciones</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/agenda-seguimiento-vacaciones">
                    Agenda de seguimiento
                  </Link>
                </MenuItem>
              </SubMenu>
            ) : null}

            {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("Responsable_Carrera_Sucesion")) ? (
              <SubMenu
                title="9 Cajas"
                icon={<i className="material-icons">inventory_2</i>}
              >
                <MenuItem>
                  <Link to="/matriz-nueve-cajas/nueve-cajas">9 Cajas</Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/matriz-nueve-cajas/admin">Administrador</Link>
                </MenuItem>
              </SubMenu>
            ) : null}

            {userRoles.length > 0 && userRoles.includes("administrador") ? (
              <SubMenu
                title="Encuesta"
                icon={<i className="material-icons">emoji_objects</i>}
              >
                <MenuItem>
                  <Link to="/encuestas">Encuestas</Link>
                </MenuItem>
              </SubMenu>
            ) : null}
          </Menu>
        </SidebarContent>
      </ProSidebar>
      <div
        onClick={() => props.onShowSidebar()}
        className={`overlay ${props.show ? "show-overlay" : ""}`}
      ></div>
    </>
  );
};

export default withRouter(SidebarDashboard);
